import React from "react";
import styled from "styled-components";
import { ITheme } from "../Themes/ThemeTypes";
import FontText from "../FontText/FontText";
import { FontSizeEnum, FontTypeEnum } from "../FontText/FontTextEnums";
import { ThemeColorEnum } from "../Themes/ThemeEnums";

const Field = styled.div<{ theme: ITheme }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({ label, children }) => (
  <Field>
    <FontText
      text={label}
      $fontType={FontTypeEnum.LABEL}
      $fontSize={FontSizeEnum.MEDIUM}
      $color={ThemeColorEnum.ON_SURFACE_VARIANT}
    />
    {children}
  </Field>
);

export default FormField;
